import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { AuthService } from '../auth/auth.service';
import { AppConfig } from '../../../app.config';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkAuthorised(state);
  }

  private checkAuthorised(state: RouterStateSnapshot): Observable<boolean> {
    if (AppConfig.settings.auth.useWindowsAuthentication) {
      return of(true);
    }

    if (state.url.indexOf(AppConfig.settings.auth.loginRoute) === 0) {
      if (this.authService.isAuthenticated) {
        this.router.navigateByUrl(AppConfig.settings.auth.defaultRoute);
        return of(false);
      }

      return of(true);
    }

    if (!this.authService.isAuthenticated) {
      return this.authService.restoreAuthenticatedSession()
        .map(restored => {
          if (restored) {
            return true;
          }

          this.router.navigate([AppConfig.settings.auth.loginRoute], {
            queryParams: { returnUrl: state.url }
          });
          return false;
        });
    }

    return of(true);
  }
}
